import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
   id: null,
   activeLeftPane: 'recentChannelList',
   params: {},
};

const leftPaneNavSlice = createSlice({
   name: 'leftPaneData',
   initialState,
   reducers: {
      setActiveLeftPane(state, action) {
         const { activeLeftPane, params } = action.payload;
         state.activeLeftPane = activeLeftPane || state.activeLeftPane;
         state.params = params;
      },
      resetActiveLeftPane() {
         return { ...initialState };
      },
   },
   extraReducers: builder => {
      builder.addCase(clearState, () => initialState);
   },
});

export const { setActiveLeftPane, resetActiveLeftPane } = leftPaneNavSlice.actions;
export default leftPaneNavSlice.reducer;
